// standings/actionTypes.js

const REQUEST_STANDINGS_DATA = '@@standings/REQUEST_STANDINGS_DATA';
const STANDINGS_DATA_RESPONSE = '@@standings/STANDINGS_DATA_RESPONSE';
const TIE_BREAKING_PROCEDURE_DATA_RESPONSE = '@@standings/TIE_BREAKING_PROCEDURE_DATA_RESPONSE';
const CHANGE_CURRENT_SEASON = '@@standings/CHANGE_CURRENT_SEASON';

export default {
    REQUEST_STANDINGS_DATA,
    STANDINGS_DATA_RESPONSE,
    TIE_BREAKING_PROCEDURE_DATA_RESPONSE,
    CHANGE_CURRENT_SEASON
}